import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useFinchPreview() {
  const [loading, setLoading] = useState(true);
  const [members, setMembers] = useState([]);

  useEffect(() => {
    axios
      .get(routes.api.managers.finch.preview)
      .then((response) => {
        setMembers(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, members };
}
